
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetopandharpurbushire() {



  const cardData =
  {
    keyword: ' Pune to Pandharpur Bus Hire',
    heading: 'Vaishnavi Travels: Pune to Pandharpur Bus Hire',
    headingDescription: 'Vaishnavi Travels provides dependable and affordable Pune to Pandharpur Bus Hire, perfect for pilgrimages, family tours, school trips, and group yatras. Our buses are spacious, well-maintained, and equipped with comfortable seating, strong air-conditioning, and ample luggage capacity, ensuring a safe and smooth journey on the Pune–Pandharpur route. With professional drivers, timely service, and flexible booking options, we make religious and group travel stress-free and convenient. Whether it’s a one-day yatra, weekend trip, or special darshan tour, Vaishnavi Travels guarantees reliable, comfortable, and hassle-free bus rental services from Pune to Pandharpur.',

    top: 'Top Places to Visit in Pandharpur with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Vitthal Rukmini Temple",
    "description": "The Vitthal Rukmini Temple is the soul of Pandharpur and one of Maharashtra’s most revered pilgrimage sites. Dedicated to Lord Vitthal (a form of Lord Krishna) and Goddess Rukmini, the temple attracts millions of devotees every year, especially during Ashadhi and Kartiki Ekadashi yatras. Pilgrims queue up for hours to touch the feet of Lord Vitthal, a tradition believed to bring blessings and peace. The temple’s black stone idol and simple architecture radiate devotion and humility. Its chants of ‘Vithoba-Rakhumai’ create an uplifting atmosphere. Vitthal Rukmini Temple is Pandharpur’s spiritual heart and eternal symbol of faith."
  },
  {
    "title": "Chandrabhaga River",
    "description": "The Chandrabhaga River, curving like a crescent moon, flows beside the Vitthal Temple and holds immense spiritual value. Pilgrims take holy dips here before darshan, believing it purifies the soul. During the Ashadhi Ekadashi yatra, the ghats are filled with warkaris singing abhangas and bhajans. The sunrise and sunset views by the river are enchanting. Locals and tourists enjoy the serene environment and cultural vibrancy of the ghats. Chandrabhaga River is Pandharpur’s sacred and scenic lifeline."
  },
  {
    "title": "ISKCON Pandharpur",
    "description": "ISKCON Pandharpur is a modern spiritual retreat promoting Lord Krishna’s teachings. With its serene temple complex, gardens, and guesthouses, it provides peaceful stays for devotees and tourists alike. Daily kirtans, bhajans, and Gita discourses create a divine atmosphere. The temple’s architecture and golden idols add to its grandeur. Visitors enjoy the prasadam served at its dining halls. ISKCON Pandharpur is the town’s international hub for devotion and peace."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "Kaikadi Maharaj Math is a unique spiritual complex showcasing life-like tableaux of stories from the Ramayana, Mahabharata, and Puranas. Spread over a large area, it blends devotion with education, making it popular among families and children. The colorful statues and scenes bring mythological stories alive in an engaging way. Pilgrims find inspiration while exploring its exhibits. Its gardens and calm atmosphere enhance the experience. Kaikadi Maharaj Math is Pandharpur’s devotional and cultural attraction."
  },
  {
    "title": "Sant Namdev Maharaj Mandir",
    "description": "Dedicated to the great saint Namdev, this temple honors his devotion to Lord Vitthal. It is said that Namdev spent much of his life in Pandharpur singing abhangas in Vitthal’s praise. The temple reflects simplicity and devotion, attracting followers of the Varkari tradition. Pilgrims find peace and inspiration here. It is especially significant during saint-related festivals and yatras. Sant Namdev Maharaj Mandir is Pandharpur’s shrine of saintly devotion and bhakti."
  },
  {
    "title": "Sant Chokhamela Samadhi",
    "description": "Sant Chokhamela, one of Maharashtra’s revered saints, has his samadhi (memorial) in Pandharpur. He is remembered for his deep devotion and social reform messages against caste barriers. Devotees visit the samadhi to honor his contributions and experience the simplicity of his teachings. The site resonates with inclusivity and equality in worship. Pilgrims chant abhangas composed by Chokhamela, keeping his legacy alive. His samadhi is Pandharpur’s reminder of devotion with social justice."
  },
  {
    "title": "Sant Dnyaneshwar Maharaj Palkhi Spot",
    "description": "Every year, the Sant Dnyaneshwar Maharaj Palkhi Yatra from Alandi to Pandharpur culminates at this sacred spot. Thousands of warkaris walk hundreds of kilometers chanting abhangas and carrying the palanquin of the saint. The site is filled with vibrant devotional energy during the yatra. It reflects the living tradition of Maharashtra’s bhakti movement. Visitors are awed by the discipline, devotion, and unity of the warkaris. This palkhi spot is Pandharpur’s annual celebration of faith and endurance."
  },
  {
    "title": "Pundalik Mandir",
    "description": "Located near the Chandrabhaga River, Pundalik Mandir is dedicated to the great devotee Pundalik, who is believed to have brought Lord Vitthal to Pandharpur. The temple is simple yet deeply significant in Vitthal’s lore. Devotees honor Pundalik’s selfless service to his parents and his ultimate devotion to Vitthal. It adds depth to the town’s spiritual legacy. Pilgrims combine this darshan with Vitthal-Rukmini Temple visits. Pundalik Mandir is Pandharpur’s shrine of devotion and gratitude."
  },
  {
    "title": "Vitthal Rukmini Mandir Mandap",
    "description": "This large hall near the Vitthal Temple serves as the cultural center for discourses, bhajans, and gatherings of warkaris. During festivals, it becomes the stage for devotional programs and saintly discourses. Its spiritual energy and devotional atmosphere leave a lasting impression. Pilgrims rest and chant here, feeling closer to Vitthal. It reflects the community and inclusivity of the Varkari tradition. The mandap is Pandharpur’s cultural and spiritual hub for devotees."
  },
  {
    "title": "Wakhari Village",
    "description": "Wakhari, a village near Pandharpur, comes alive during the annual yatra as lakhs of warkaris rest here before entering Pandharpur. It symbolizes the unity and devotion of the Varkari movement. The entire village turns into a festival ground with chants, music, and simple meals offered by locals. Tourists witness the incredible discipline and spiritual passion of the warkaris. The village has become synonymous with hospitality and devotion. Wakhari is Pandharpur’s living tradition of service and faith."
  }
],

"services": [
{
"name": "Pandharpur Bus from Pune",
"description": "Dedicated bus services from Pune to Pandharpur tailored for spiritual and pilgrimage travelers. Ideal for groups, families, and temple visitors, our buses are maintained for long-distance travel comfort. Enjoy early morning departures, group-friendly seating, and reliable pickups for seamless travel to Pandharpur, Maharashtra’s revered pilgrimage destination."
},
{
"name": "AC Bus for Pandharpur Darshan",
"description": "Travel in comfort with our air-conditioned bus rentals from Pune to Pandharpur. Perfect for summer journeys or long trips, these buses feature reclining seats, clean interiors, and smooth suspension. Best suited for elderly passengers, families, and religious tour groups seeking a relaxed ride to the famous Vitthal Rukmini Temple."
},
{
"name": "Non AC Pandharpur Bus Hire Pune",
"description": "Budget-friendly non-AC bus options for Pune to Pandharpur pilgrims and travelers. These buses are well-maintained and provide comfortable seating with adequate ventilation for economical travel. A preferred choice for Varkaris, local mandals, and school religious tours looking for cost-effective transport solutions."
},
{
"name": "Pilgrimage Bus Pune to Pandharpur",
"description": "Spiritual tour bus hire from Pune to Pandharpur designed especially for devotees and pilgrimage groups. Includes customizable departure times, en-route halts for meals, and experienced drivers familiar with temple routes and timings. Optional services include onboard announcements, devotional music, and group coordination support."
},
{
"name": "50 Seater Bus to Pandharpur",
"description": "Spacious 50-seater buses for large group trips from Pune to Pandharpur, ideal for religious events, school yatras, or community tours. Equipped with overhead storage, wide aisles, and cushioned seating, ensuring a safe and comfortable ride even on long journeys. Available in AC and non-AC variants with trained drivers."
},
{
"name": "Outstation Bus Pandharpur Trip",
"description": "Professional outstation bus rental service from Pune to Pandharpur offering one-way and round-trip packages. Our fleet includes 32, 40, and 50-seater buses suited for family groups, corporate retreats, or religious tours. All bookings include licensed drivers, route planning assistance, and 24/7 support throughout your trip."
},
{
"name": "Group Travel Bus Pandharpur Pune",
"description": "Comfortable and reliable group travel buses for Pandharpur from Pune, accommodating varying group sizes with multiple bus options. Our services include pickup from multiple city points, coordinated schedules, and add-on features like water bottles and custom signage for easy group identification. Best for organized religious gatherings and society trips."
},
{
"name": "Religious Group Bus Rental Pune",
"description": "Dedicated religious tour buses for Pandharpur travel from Pune. Ideal for spiritual mandals, bhajan groups, and senior citizen yatras. Our packages include early bookings during festival seasons like Ashadi Ekadashi and Kartiki Ekadashi, as well as flexible return schedules and assistance with parking near temple premises."
},
{
"name": "Family Bus Hire Pandharpur Trip",
"description": "Private family bus hire for Pandharpur trips from Pune offering comfort, safety, and privacy. Available in 17 to 50-seater options, these buses ensure that the entire family travels together with adequate space for luggage and temple offerings. Drivers assist with stops for meals and ensure senior-friendly boarding options."
},
{
"name": "Varkari Yatra Bus Pune",
"description": "Specialized Varkari Yatra buses from Pune to Pandharpur, designed for traditional pilgrim walkers or mandals participating in the Palkhi procession. Our buses offer support transport for luggage, rest, and return journey needs, especially during peak Ashadi or Kartiki Yatra seasons. Includes basic first-aid and coordination assistance for large groups."
},
{
"name": "Bus for Pandharpur Temple Visit",
"description": "One-day and weekend bus rentals for temple visits to Pandharpur from Pune. Whether you're planning an early morning darshan or a relaxed spiritual retreat, our buses ensure punctual arrivals, temple-route familiarity, and return trip reliability. Ideal for senior citizens, local spiritual groups, and temple devotees."
},
{
"name": "Pune to Pandharpur Travel by Bus",
"description": "Trusted bus transportation service from Pune to Pandharpur offering a blend of comfort, safety, and spiritual purpose. Ideal for day trips, religious events, and weekend getaways. Choose from AC or non-AC buses based on your group’s preference. Our drivers are trained to ensure a smooth and respectful journey."
},
{
"name": "Online Pandharpur Bus Booking Pune",
"description": "Book your Pune to Pandharpur bus online in minutes with our seamless reservation platform. Browse multiple bus options, check availability, compare rates, and confirm instantly. Digital invoices, real-time tracking, and customer support ensure a stress-free booking experience for individuals, groups, and travel planners."
}
],
"tableData": [
["Pandharpur Bus from Pune", "AC Bus for Pandharpur Darshan"],
["Non AC Pandharpur Bus Hire Pune", "Pilgrimage Bus Pune to Pandharpur"],
["50 Seater Bus to Pandharpur", "Outstation Bus Pandharpur Trip"],
["Group Travel Bus Pandharpur Pune", "Religious Group Bus Rental Pune"],
["Family Bus Hire Pandharpur Trip", "Varkari Yatra Bus Pune"],
["Bus for Pandharpur Temple Visit", "Pune to Pandharpur Travel by Bus"],
["Online Pandharpur Bus Booking Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Pandharpur Bus Hire Service",
    "WhyChoosedescription": "Vaishnavi Travels offers trustworthy and affordable bus hire services from Pune to Pandharpur, ideal for pilgrimage and group travel."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses provide ample legroom and cushioned seats for a comfortable journey to Pandharpur."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Every bus is regularly serviced and thoroughly cleaned to ensure safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Pune to Pandharpur Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your group size and travel plans."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Pandharpur Route",
    "WhyChoosedescription": "Our professional drivers ensure safe, punctual, and courteous service with expert knowledge of the route."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing covers fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage, Family, and Group Travel",
    "WhyChoosedescription": "Perfect for religious tours, family outings, and group trips between Pune and Pandharpur."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Vaishnavi Travels offers round-the-clock customer service to assist with bookings and travel queries."
  }
]
























  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide bus hire services from Pune to Pandharpur?',
      answer: 'Yes, Vaishnavi Travels offers reliable bus hire services from Pune to Pandharpur, ideal for religious pilgrimages, group tours, and family trips.',
    },
    {
      question: 'What types of buses are available for Pune to Pandharpur trips?',
      answer: 'We provide various options including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, to suit different group sizes and comfort needs.',
    },
    {
      question: 'What is the approximate cost for hiring a bus from Pune to Pandharpur?',
      answer: 'Costs typically start from ₹8,500 for a one-day trip in a 32 seater tempo traveller. Prices vary based on bus type and trip duration, with customized quotes available.',
    },
    {
      question: 'Are drivers included in the bus hire service?',
      answer: 'Yes, all bus hires include experienced and licensed drivers familiar with the Pune-Pandharpur route for safe and comfortable travel.',
    },
    {
      question: 'Can the itinerary be customized for the Pandharpur trip?',
      answer: 'Definitely. We tailor the itinerary, stops, and timings based on your group’s preferences and requirements.',
    },
    {
      question: 'How far in advance should I book a bus from Pune to Pandharpur?',
      answer: 'Booking 3-5 days in advance is recommended, especially during festival seasons and weekends, to ensure availability.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the fare?',
      answer: 'Tolls, parking fees, driver allowances, and permits are usually extra and will be clearly communicated during booking.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Prashant More",
    position: "Pilgrimage Group Leader",
    feedback:
      "Vaishnavi Travels made our Pune to Pandharpur pilgrimage comfortable and hassle-free. The bus was clean and spacious, and the driver was punctual and courteous. Highly recommended for group travel!",
    rating: 5,
  },
  {
    name: "Mrs. Sneha Kulkarni",
    position: "Family Organizer",
    feedback:
      "We hired a 40 seater AC bus for our family trip to Pandharpur through Vaishnavi Travels. The service was excellent, the bus was well-maintained, and the driver was very professional. Will definitely use them again.",
    rating: 5,
    style: "style-2",
  }
];
























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pandharpur Bus Hire",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-pandharpur-bus.jpg",
  "description": "Book Pune to Pandharpur bus hire with Vaishnavi Travels for comfortable AC and Non AC buses ideal for pilgrimage trips, family travel, and group tours.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.75",
    "ratingCount": "1200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-pandharpur-bus-hire"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Pandharpur Bus Hire | AC & Non AC Pilgrimage Bus | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to Pandharpur bus hire with Vaishnavi Travels for comfortable AC and Non AC buses ideal for pilgrimage trips, family travel, and group tours."
  />
  <meta
    name="keywords"
    content="Pandharpur Bus from Pune, AC Bus for Pandharpur Darshan, Non AC Pandharpur Bus Hire Pune, Pilgrimage Bus Pune to Pandharpur, 50 Seater Bus to Pandharpur, Outstation Bus Pandharpur Trip, Group Travel Bus Pandharpur Pune, Religious Group Bus Rental Pune, Family Bus Hire Pandharpur Trip, Varkari Yatra Bus Pune, Bus for Pandharpur Temple Visit, Pune to Pandharpur Travel by Bus, Online Pandharpur Bus Booking Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopandharpurbushire;